import { memo } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { WebRoutes } from "consts/enpoints/web";
import CustomBreadcrumbs from "lib/custom-breadcrumbs";
import { Link, Outlet, useLocation } from "infrastructure/router";

const ROUTES = WebRoutes.Setup.WhatsAppMessaging;

const TABS = [
    { value: ROUTES.MessageLogs, label: 'Message Logs' },
    { value: ROUTES.PhoneVerifications, label: 'Phone Verifications' },
    { value: ROUTES.FailedPhoneVerifications, label: 'Failed Phone Verifications' },
    { value: ROUTES.MessageSetups, label: 'Message Setups' },
    { value: ROUTES.TemplateSetups, label: 'Template Setups' }
] as const;

const isUnder = (pathname: string, path: string) =>
    pathname === path || pathname.startsWith(`${path}/`);

const WhatsAppMessagingLayout = () => {
    const { pathname } = useLocation();

    const activeTab = TABS.find(tab => isUnder(pathname, tab.value)) ?? TABS[0];

    return (
        <Box sx={{ px: '20px' }}>
            <CustomBreadcrumbs
                sx={{ mb: 2 }}
                heading='WhatsApp Messaging'
                links={[
                    { name: 'Setup' },
                    { name: 'WhatsApp Messaging' }
                ]}
            />

            <Tabs
                value={activeTab.value}
                sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
                variant='scrollable'
                scrollButtons='auto'
            >
                {TABS.map(({ value, label }) => (
                    <Tab
                        key={value}
                        label={label}
                        value={value}
                        component={Link}
                        to={value}
                        data-test-id={`whatsAppMessaging.tab.${value}`}
                    />
                ))}
            </Tabs>

            <Outlet />
        </Box>
    );
};

export default memo(WhatsAppMessagingLayout);
